const e=e=>e.toLowerCase().trim().replace(/"/g,``).replace(/\s/g,`-`).replace(/'/g,``);export{e as normalizeFontFamilyName};
//# sourceMappingURL=normalize-font-family-name.js.map